import { useSelector } from "react-redux";

import { selectIsSoftball } from "../../../../store/slices/socket/selectors";
import { boundNumberToRange } from "../../../../utils/boundNumberToRange";

interface Props {
  style?: React.CSSProperties;
  ballX?: number;
  ballY?: number;
  twoStrikeZone: boolean;
  perspective: "pitcher" | "catcher";
  isStrike?: boolean;
}

export const StrikeZoneVisualization: React.FC<Props> = ({
  style,
  ballX,
  ballY,
  twoStrikeZone,
  perspective,
  isStrike,
}) => {
  const isSoftball = useSelector(selectIsSoftball);
  const strokeFill = "#374151"; // gray-700

  // Softball vs baseball radius determined by ball size
  const ballRadius = isSoftball ? "41" : "31.5";

  const fill = isStrike ? "#3B82F6" : strokeFill; // blue-500 if strike, gray-700 otherwise

  return (
    <svg
      style={style || { width: "100%" }}
      viewBox="0 0 381 477"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M132.441 0.916504V472.133M264.671 0.916504V472.133M379.642 311.142H12.9209M379.642 157.581H12.9209"
        stroke={fill}
        strokeMiterlimit="3.99933"
      />

      {/* Extended strike zone, an extra ball of space on top, bottom, and corners */}
      {twoStrikeZone && (
        <rect
          x="-47.5791"
          y="-59.5835"
          width="488.824"
          height="592.217"
          stroke={strokeFill}
          strokeWidth="5"
          strokeDasharray="5,5"
          rx="15"
        />
      )}

      <rect
        x="15.4209"
        y="3.4165"
        width="362.824"
        height="466.217"
        stroke={fill}
        strokeWidth="5"
        rx="15"
      />
      {ballX && ballY && (
        <circle
          // boundNumberToRange keeps the ball svg reasonably close to the zone
          // in the event that it's WAY far away, for the sake of looking pretty
          cx={`${boundNumberToRange(-50, ballX, 150) || -100000000}%`}
          cy={`${boundNumberToRange(-50, ballY, 145) || -100000000}%`}
          r={ballRadius}
          fill={fill}
        />
      )}

      {perspective === "catcher" && (
        <path
          d="M381.508 622.419L13.9757 622.416L13.976 659.3L196.425 698.161L381.508 659.3V522.419Z"
          fill={strokeFill}
          fillOpacity="0.33"
        />
      )}
      {perspective === "pitcher" && (
        <path
          d="M381.083 658.055L13.550859 658.058L13.551244 621.174L196 582.313L381.083 621.174V571.055Z"
          fill={strokeFill}
          fillOpacity="0.33"
        />
      )}
    </svg>
  );
};
